import { createClient, SupabaseClient } from "@supabase/supabase-js"

/**
 * Get supabase client.
 * @param key - Optional key override. Falls back to SUPA_ROOT_KEY (server) or GATSBY_SUPA_ANON_KEY (client).
 * @returns SupabaseClient
 */
export const getClient = (key?: string): SupabaseClient => {
  // Server-side uses SUPA_ROOT_KEY, client-side uses GATSBY_SUPA_KEY
  const secret =
    key ||
    globalThis.process.env["SUPA_ROOT_KEY"] ||
    process.env.GATSBY_SUPA_KEY
  return createClient(process.env.GATSBY_SUPA_ENDPOINT!, secret!)
}
